import { StandardProceessEnv } from '@iotv/iotv-v3-types'

/** where react-native cannot be passed envs to process - this is either tempoarary or may be regexed at some point by pre deploy script */
export const fallBackEns: StandardProceessEnv = {
    AWS_DEFAULT_REGION: "ap-southeast-2",
    accountId: "xxxxxxxxxxxxx",
    projectCode: "iotv",
    projectName: "iotv",
    stage: 'dev',
    AWS_PROFILE: "iotv-test",
    
} 